import React from 'react'
import Button from '@material-ui/core/Button';
import DeleteForever from '@material-ui/icons/DeleteForever';
import DataProvider from '../DataProvider.js'

const styles = ({
    deleteButton: {
        borderRadius: '5px',
        color: 'white',
        backgroundColor: 'red'
    },
    deleteButtonLight: {
        borderRadius: '5px',
        color: 'red',
        backgroundColor: 'transparent'
    }
});

const ConfirmDeleteButton = (props) => {

    const attemptToDelete = () => {
        if (props.dataprovidersource === 'organizations' || props.dataprovidersource === 'dispatch-tablets') {
            if (window.confirm(`Are you sure you wish to delete?`)) { onDelete() } else { onCancel() }
        } else {
            onDelete()
        }
    }

    const onCancel = () => { }

    const onDelete = () => {
        if (window.confirm(`Warning, this cannot be undone.`)) { confirmedDelete() } else { onCancel() }
    }

    const confirmedDelete = async () => {
        await DataProvider.delete(props.dataprovidersource, { id: props.record.id, previousData: props.record })
        props.update()
    }


    return (

        <div >
            <Button onClick={attemptToDelete} style={props.filled ? styles.deleteButton: styles.deleteButtonLight}>
                Delete {<DeleteForever />}
            </Button>
        </div>
    )

}

export default ConfirmDeleteButton